{
    "coordinates": [
        -29.841732,
        -67.764815
    ],
    "tooltip": "Chañares",
    "title": "Chañares Formation",
    "country": "Argentina",
    "period": "Triassic",
    "alt": "TODO"
}
